export type GtmCustomerType = 'new' | 'existing'

export interface GtmUserProperties {
  search_engine_version: 1 | 2
  nav_version: 1 | 2
  customer_type?: GtmCustomerType
}

export function resolveSearchEngineVersion(isHybrid: boolean): 1 | 2 {
  return isHybrid ? 2 : 1
}

export function resolveCustomerType(hasAnyOrders: boolean): GtmCustomerType {
  return hasAnyOrders ? 'existing' : 'new'
}

/**
 * Builds user-scoped GA4 props, or `null` until logged in (no guessed defaults).
 */
export function resolveGtmUserProperties(
  opts: {
    hasUserData: boolean
    isHybrid: boolean
    layoutVersion: 1 | 2
    hasAnyOrders: boolean
    hasResolvedOrderHistory: boolean
  },
): GtmUserProperties | null {
  if (!opts.hasUserData) return null

  const props: GtmUserProperties = {
    search_engine_version: resolveSearchEngineVersion(opts.isHybrid),
    nav_version: opts.layoutVersion,
  }

  // Wait for order-history (or a known hasAnyOrders flip) so existing users aren't briefly "new".
  if (opts.hasResolvedOrderHistory || opts.hasAnyOrders)
    props.customer_type = resolveCustomerType(opts.hasAnyOrders)

  return props
}

/**
 * Merge in place; skip non-objects; existing keys win (purchase snapshot).
 */
export function applyGtmUserProperties(
  event: Record<string, unknown>,
  props: GtmUserProperties | null,
): void {
  if (!props) return
  if (Object.prototype.toString.call(event) !== '[object Object]') return

  if (event.search_engine_version === undefined)
    event.search_engine_version = props.search_engine_version
  if (event.nav_version === undefined)
    event.nav_version = props.nav_version
  if (event.customer_type === undefined && props.customer_type !== undefined)
    event.customer_type = props.customer_type
}
